var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLayout = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C6.44771 0 6 0.447715 6 1V5C6 5.55228 6.44772 6 7 6H16C16.5523 6 17 5.55228 17 5V1C17 0.447715 16.5523 0 16 0H7ZM12 12C12 12.5523 12.4477 13 13 13H16C16.5523 13 17 12.5523 17 12V8C17 7.44772 16.5523 7 16 7H13C12.4477 7 12 7.44772 12 8V12ZM0 12C0 12.5523 0.447715 13 1 13H4C4.55228 13 5 12.5523 5 12V1C5 0.447715 4.55228 0 4 0H1C0.447715 0 0 0.447715 0 1V12ZM6 12C6 12.5523 6.44772 13 7 13H10C10.5523 13 11 12.5523 11 12V8C11 7.44772 10.5523 7 10 7H7C6.44772 7 6 7.44772 6 8V12Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLayout, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Layout.d1006518.svg";
export { ForwardRef as ReactComponent };